
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import OnlineService from '@/services/OnlineService'

export default Vue.extend({
  name: 'SignUp',
  created () {
    this.$store.dispatch('clearLogin')
    this.$store.commit('isLoading', true)
    this.$store.commit('isLoadingForce', true)
    const companyId = process.env.VUE_APP_COMPANY_ID
    OnlineService.signUp(companyId).then(data => {
      window.location.href = data.signUpUrl
    })
  }
})
